import React from "react";
import { ReactComponent as Logout } from "assets/img/icons/logout.svg";
import AuthService from "services/AuthService";
import { useDispatch } from "react-redux";
import * as timelineActions from "reteamStore/actions";
import { useUserContext } from "store/contexts/userContext";

export default function Header(color = "white") {
  const { setUser, setIsAuthenticated } = useUserContext();
  const dispatch = useDispatch();

  const handleLogout = async () => {
    await AuthService.logout();
    try {
    } catch (e) {
      console.log(e);
    }
    dispatch(timelineActions.clearAllTeams());

    localStorage.clear();
    setUser(null);
    setIsAuthenticated(false);
  };

  return (
    <div className="microsoftTeamsHeader">
      <div className="microsoftLogout">
        <li onClick={handleLogout}>
          <Logout className="userProfileAvatar" />
          <span>Sign Out</span>
        </li>
      </div>
      <div className="microsoftHeaderContent">Please Select the team</div>
    </div>
  );
}
